// Mirrors demanda/server/constants/header_constants.py — keep header names in sync with the backend.
export const HeaderConstants = {
  SESSION_ID_HEADER: "X-Session-ID",
  USER_ID_HEADER: "X-User-Id",
  POSTHOG_SESSION_ID_HEADER: "X-PostHog-Session-Id",
} as const;
